import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const CameraIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 15.2C13.7674 15.2 15.2 13.7673 15.2 12C15.2 10.2327 13.7674 8.8 12 8.8C10.2327 8.8 8.80005 10.2327 8.80005 12C8.80005 13.7673 10.2327 15.2 12 15.2Z"
          fill="black"
          fill-opacity="0.87"
        />
        <path
          d="M9 2L7.17 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H16.83L15 2H9ZM12 17C9.24 17 7 14.76 7 12C7 9.24 9.24 7 12 7C14.76 7 17 9.24 17 12C17 14.76 14.76 17 12 17Z"
          fill="black"
          fill-opacity="0.87"
        />
      </svg>
    )
  },
)
